import React, { FC } from "react";
import { useMedia } from "react-use";

import { ISectionProps, Section } from "@/components/Section";
import { MEDIA_SIZE_SM } from "@/core/media";
import { IWorkOrder } from "@/data/work-orders";

import { WorkOrderDigest } from "./WorkOrderDigest";
import { WorkOrderSpecification } from "./WorkOrderSpecification";
import { WorkOrderSupplier } from "./WorkOrderSupplier";

interface IWorkOrderInformationProps extends ISectionProps {
  workOrder: IWorkOrder;
}

export const WorkOrderInformation: FC<IWorkOrderInformationProps> = ({ workOrder, ...props }) => {
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  return (
    <Section
      width={12}
      direction="column"
      background="background-card"
      shadow={isSmallScreen ? "none" : "default"}
      borderRadius={!isSmallScreen}
      padding={["md", "lg"]}
      innerMargin="md"
      innerBorder
      {...props}>
      <WorkOrderSupplier workOrder={workOrder} padding={[false, false, "md", false]} />

      <WorkOrderDigest workOrder={workOrder} />

      <WorkOrderSpecification workOrder={workOrder} padding={["md", false, false, false]} />
    </Section>
  );
};
